import { Flex, Icon } from '@chakra-ui/react';
import { TruncatedTextWithTooltip } from '@/ui/TooltipText';
import { ActionItemProps } from './actionRegistry';
import { StatusIndicator } from './StatusIndicator';
import { getItemStyles } from './itemStyles';

/**
 * Default item component - used when no specific component is registered
 */
export const DefaultItem = ({ item }: ActionItemProps) => {
  const styles = getItemStyles(item.status);
  const isFailed = item.status === 'failed';

  return (
    <Flex
      py="12px"
      px="20px"
      alignItems={isFailed ? 'flex-start' : 'center'}
      justifyContent="space-between"
      flexDir={isFailed ? 'column' : 'row'}
      borderBottom="1px solid"
      borderColor={styles.borderColor}
      bg={styles.container.bg}
      _first={{ borderTop: '1px solid', borderColor: styles.borderColor }}
      _last={{
        borderBottom: isFailed ? '1px solid' : 'none',
        borderColor: styles.borderColor,
      }}
    >
      <Flex alignItems="center" gap="10px" flex={1} minW={0}>
        {item.icon && (
          <Icon as={item.icon} w="20px" h="20px" color="secondary-700" />
        )}
        <TruncatedTextWithTooltip
          text={item.name}
          size="sm"
          flex={1}
          color={styles.text.color}
          placement="top"
          toolTipVariant="default"
          maxW="100%"
        />
      </Flex>

      <Flex alignItems="center" flexShrink={0}>
        <StatusIndicator
          status={item.status}
          progress={item.progress}
          errorType={item.errorType}
        />
      </Flex>
    </Flex>
  );
};
